import React, { useEffect, useState, useContext } from "react";

// import { redirect } from "react-router-dom";
import { Row, Card, CardGroup } from "react-bootstrap";

import SisenseHomePageWidget from "./components/SisenseHomePageWidget";
import { Link } from "react-router-dom";
import {
  loadScript,
  isLoaded,
} from "../../../components/SiSense/SiSenseScriptLoader";
import { UserContext } from "shared/context/UserContext";

import "./HomeStyles.css";

import PendingHomePageRemittances from "./PendingHomePageRemittances";
import { useParentCompanyLocationValidation } from "components/hooks/useParentCompanyLocationValidation";
import parse from "html-react-parser";

import { useFetchHomepageNewsAndHappeningsData } from "./hooks/useFetchHomepageNewsAndHappeningsData";

import { useGetHomepageSisenseWidgetArgs } from "./hooks/useGetHomepageSisenseWidgetArgs";

export default function Home(props) {
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const url = process.env.REACT_APP_SisenseURI + "/js/frame.js";

  const user = useContext(UserContext);

  const { eraOnly } = useParentCompanyLocationValidation();

  let hasRecSubscription = user && user.hasRecSubscription;

  //see if there are any rec locations
  let hasRecLocations =
    user && user.recLocations && user.recLocations.length > 0;

  //alert("hasRecLocations: " + hasRecLocations);

  let {
    data: newsAndHappeningsData,
    isLoading: newsAndHappeningsDataIsLoading,
  } = useFetchHomepageNewsAndHappeningsData(user.email);

  useEffect(() => {
    if (isLoaded(url)) {
      setScriptLoaded(true);
    } else {
      loadScript(url)
        .then(() => {
          setScriptLoaded(true);
        })
        .catch((e) => console.log(e));
    }
  }, []);

  //console.log("rec locations", user.recLocations);

  //get all information (args) for the sisense widgets from the hook

  //let { sisenseArgs } = useGetHomepageSisenseWidgetArgs(user.recLocations);

  //only set the sisense args if the user has rec locations
  //this is to prevent the sisense widgets from loading if the user does not have rec

  let { sisenseArgs } = useGetHomepageSisenseWidgetArgs(
    hasRecLocations ? user.recLocations : null
  );

  //get identifiers for the sisense widgets
  let agingSisenseId =
    "homepageagingwidget" +
    (sisenseArgs && sisenseArgs.filterHash ? sisenseArgs.filterHash : "");
  let adjustmentTrackerSisenseId =
    "homepagefeeadjustwidget" +
    (sisenseArgs && sisenseArgs.filterHash ? sisenseArgs.filterHash : "");

  const Line = ({ sss }) => <hr style={{ height: 5 }}></hr>;

  return (
    // redirectToByod ?
    //     <redirect to={{ pathname: 'Byod' }} /> :
    <React.Fragment>
      <div className="dashboard-padding-wrapper">
        <Row className="no-gutters dashboard-card-group h-50" as={CardGroup}>
          <Card className="dashboard-card">
            <Card.Body className="remove-hyperLinkLine">
              <Card.Title className="text-center add-hyperLinkLine">
                <Link
                  to={hasRecSubscription ? "/RemitLookUp" : "#"}
                  className="add-hyperLinkLine homepageCardLinkColors"
                >
                  Pending Remittances
                </Link>
              </Card.Title>
              {hasRecSubscription ? (
                <div className="dashboard-widget-wrapper">
                  <PendingHomePageRemittances passedProps={props} />
                </div>
              ) : (
                <div className="dashboard-widget-wrapper">
                  This feature is available with the purchase of RecRx, contact
                  sales@Net-Rx.com
                </div>
              )}
            </Card.Body>
          </Card>
          <Card className="dashboard-card" style={{ alignItems: "center" }}>
            <Card.Body
              as={Link}
              to={hasRecSubscription ? "/Aging" : "#"}
              className="remove-hyperLinkLine"
            >
              <Card.Title className="text-center add-hyperLinkLine">
                Reconciliation and Aging Manager: Aging
              </Card.Title>
              {!hasRecLocations || eraOnly ? (
                <div className="dashboard-widget-wrapper">
                  This feature has not been enabled for your account. Please
                  contact Net-Rx at 866-336-3879 to subscribe to this feature.
                </div>
              ) : hasRecSubscription ? (
                <div
                  className="dashboard-widget-wrapper"
                  style={{ position: "absolute" }}
                >
                  {scriptLoaded &&
                    sisenseArgs &&
                    sisenseArgs.agingSisenseUrl && (
                      <SisenseHomePageWidget
                        key={agingSisenseId}
                        iframeUrl={sisenseArgs.agingSisenseUrl}
                        iframeId={agingSisenseId}
                      />
                    )}
                </div>
              ) : (
                <div className="dashboard-widget-wrapper">
                  This feature is available with the purchase of RecRx, contact
                  sales@Net-Rx.com
                </div>
              )}
            </Card.Body>
          </Card>
          <Card className="dashboard-card">
            <Card.Body
              as={Link}
              to={hasRecSubscription ? "/FeeAdjustment" : "#"}
              className="remove-hyperLinkLine"
            >
              <Card.Title className="text-center add-hyperLinkLine">
                Fee & Adjustment Tracker - Previous Month
              </Card.Title>
              {!hasRecLocations || eraOnly ? (
                <div className="dashboard-widget-wrapper">
                  This feature has not been enabled for your account. Please
                  contact Net-Rx at 866-336-3879 to subscribe to this feature.
                </div>
              ) : hasRecSubscription ? (
                <div className="dashboard-widget-wrapper">
                  {scriptLoaded &&
                    sisenseArgs &&
                    sisenseArgs.feeAdjustjentSisenseUrl && (
                      <SisenseHomePageWidget
                        key={adjustmentTrackerSisenseId}
                        iframeUrl={sisenseArgs.feeAdjustjentSisenseUrl}
                        iframeId={adjustmentTrackerSisenseId}
                      />
                    )}
                </div>
              ) : (
                <div className="dashboard-widget-wrapper">
                  This feature is available with the purchase of RecRx, contact
                  sales@Net-Rx.com
                </div>
              )}
            </Card.Body>
          </Card>
        </Row>
        <Row className="no-gutters dashboard-card-group h-50" as={CardGroup}>
          <Card className="dashboard-card">
            <Card.Body>
              <Card.Title className="text-center add-hyperLinkLine">
                News and Alerts
              </Card.Title>
              <div className="newsBody">
                {!newsAndHappeningsDataIsLoading &&
                  newsAndHappeningsData &&
                  newsAndHappeningsData.map((data) => {
                    return data.NE_TYPE == "1" ? (
                      <div key={`news-${data.NE_TYPE}-${data.NE_Title}`}>
                        <Card.Title className="text-left">
                          {data.NE_Title}
                        </Card.Title>
                        <div className="card-text">
                          {parse(data.NE_Details)}
                        </div>
                        <Line></Line>
                      </div>
                    ) : (
                      ""
                    );
                  })}
              </div>
            </Card.Body>
          </Card>

          <Card className="dashboard-card">
            <Card.Body>
              <Card.Title className="text-center  add-hyperLinkLine">
                Net Rx happenings
              </Card.Title>
              <div className="newsBody">
                {!newsAndHappeningsDataIsLoading &&
                  newsAndHappeningsData &&
                  newsAndHappeningsData.map((data) => {
                    return data.NE_TYPE == "3" ? (
                      <div key={`happening-${data.NE_TYPE}-${data.NE_Title}`}>
                        <Card.Title className="text-left">
                          {data.NE_Title}
                        </Card.Title>
                        <div className="card-text">
                          {parse(data.NE_Details)}
                        </div>
                        <Line></Line>
                      </div>
                    ) : (
                      ""
                    );
                  })}
              </div>
            </Card.Body>
          </Card>
        </Row>
      </div>
    </React.Fragment>
  );
}
